import { Autocomplete, Chip, TextField } from '@mui/material'
import { FC, useEffect, useRef } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import cn from '@/utils/cn'
import { ActionCreatorWithPayload } from '@reduxjs/toolkit'
import { useActions, useAppSelector } from '@/hooks'
import { filterSystemSelector } from '@/store/filterSystemsSlise'
import { DeviceType } from '@/types/enums'

const s = cn('custom-autocomplete')

type Item = {
  name: string
  id: number
  separated?: boolean
}

interface ICustomAutocomplete {
  options: Item[]
  filter: number[]
  setFilter: ActionCreatorWithPayload<number[]>
  nameForStorage: string
  disabled?: boolean
  label?: string
  isMap?: boolean
}

type CustomAutocompleteProps = ICustomAutocomplete
const CustomAutocompleteRedux: FC<CustomAutocompleteProps> = ({
  options,
  filter,
  setFilter,
  nameForStorage,
  disabled,
  label,
  isMap,
}) => {
  const ref = useRef(null)
  const { setIsSearch, setIsSearchTanks } = useActions()
  const { isSearch } = useAppSelector(filterSystemSelector)
  const [, setSearchParams] = useSearchParams()
  const { pathname } = useLocation()
  // const filteredOptions = options.filter(
  //   (option) => option.id !== 16 && option.id !== 17
  // )

  const sortedOptions = [...(options ?? [])].sort((a, b) => {
    if (a.id === DeviceType.dtp) return 1
    if (b.id === DeviceType.dtp) return -1
    return 0
  })

  useEffect(() => {
    if (ref !== null && !disabled) {
      const el = ref.current as unknown as HTMLDivElement
      if (el !== null) {
        const chip = el.querySelectorAll('.MuiChip-label')
        const cross = el.querySelectorAll('.MuiChip-deleteIcon')
        const isAll = chip.length > 0 ? chip[0]?.innerHTML === 'Все' : null
        if (isAll === null) {
          return
        }
        if (isAll) {
          cross[0].setAttribute('style', 'display: none;')
        } else {
          cross[0].removeAttribute('style')
        }
      }
    }
  }, [filter, disabled, options])

  return (
    <Autocomplete
      limitTags={1}
      ref={ref}
      className={s({ is_map: isMap })}
      multiple
      color='primary'
      fullWidth
      disableCloseOnSelect
      disabled={disabled}
      size='small'
      options={sortedOptions}
      value={sortedOptions?.filter((item) => filter?.includes(item.id))}
      getOptionLabel={(option) => option.name}
      onChange={(e, newValue) => {
        setIsSearch(!isSearch)
        setIsSearchTanks(!isSearch)
        const arr = newValue.map((item) => item.id)

        const hasId15 = arr.includes(15)
        const previousHasId15 = filter?.includes(15) ?? false

        if (hasId15 && !previousHasId15) {
          setFilter([15])
          localStorage.setItem(nameForStorage, JSON.stringify([15]))
          return
        }

        if (previousHasId15 && hasId15 && arr.length > 1) {
          const arrWithout15 = arr.filter((id) => id !== 15)
          if (arrWithout15.length === 0) {
            setFilter([0])
            localStorage.setItem(nameForStorage, JSON.stringify([0]))
            setSearchParams({})
          } else {
            setFilter(arrWithout15)
            localStorage.setItem(nameForStorage, JSON.stringify(arrWithout15))
          }
          return
        }

        if (previousHasId15 && !hasId15) {
          const arrWithout15 = arr.filter((id) => id !== 15)
          if (arrWithout15.length === 0) {
            setFilter([0])
            localStorage.setItem(nameForStorage, JSON.stringify([0]))
            setSearchParams({})
          } else {
            setFilter(arrWithout15)
            localStorage.setItem(nameForStorage, JSON.stringify(arrWithout15))
          }
          return
        }

        const index0 = arr.findIndex((item) => item === 0)
        if (index0 > -1 && arr.length > 1 && index0 === 0) {
          arr.splice(index0, 1)
        } else if (arr.includes(0)) {
          arr.splice(0, arr.length, 0)
        }
        if (arr.length === 0) {
          setFilter([0])
          localStorage.setItem(nameForStorage, JSON.stringify([0]))
          setSearchParams({})
        } else {
          setFilter(arr)
          localStorage.setItem(nameForStorage, JSON.stringify(arr))
          if (arr.length === 1 && arr[0] === 0) {
            setSearchParams({})
          }
        }
      }}
      renderOption={(props, option) => {
        const isSeparated = option.id === DeviceType.dtp
        return (
          <li
            {...props}
            style={{
              ...props.style,
              borderTop: isSeparated ? '2px solid #0072BC' : 'none',
            }}
          >
            {option.name}
          </li>
        )
      }}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => {
          const { key, ...tagProps } = getTagProps({ index })
          return (
            <>
              <Chip
                key={key}
                {...tagProps}
                label={option.name}
                variant='filled'
                size={'small'}
              />
            </>
          )
        })
      }
      renderInput={(params) => (
        <TextField
          {...params}
          margin='none'
          variant='filled'
          label={label ? label : `Фильтр систем`}
        />
      )}
    />
  )
}

export default CustomAutocompleteRedux
